import {AbstractControl, ValidatorFn} from '@angular/forms';

export function matchValidator(controlName: string, matchingControlName: string): ValidatorFn {
    return (group: AbstractControl) => {
        const control = group.get(controlName);
        const matchingControl = group.get(matchingControlName);

        if (!control || !matchingControl) {
            return null;
        }

        if (matchingControl.errors && !matchingControl.errors['match']) {
            return null;
        }

        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ match: true });
        } else {
            matchingControl.setErrors(null);
        }
        return null;
    };
}